import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine } from "recharts";

const TICK = { fontSize: 11 };
const DOMAIN = ["auto", "auto"];
const TOOLTIP = { backgroundColor: "#243044", border: "1px solid #2d3f5a", borderRadius: 8 };
const LABEL = { color: "#f0e6d3" };
const WEIGHT_DOT = { fill: "#c9a84c", r: 4 };
const IMC_DOT = { fill: "#818cf8", r: 4 };
const ACTIVE_DOT = { r: 6 };

export const TrendChart = memo(function TrendChart({ data, metric = "peso", height = 220, testId }) {
  const { t } = useTranslation();
  const isWeight = metric === "peso";
  const formatter = useCallback((value) => [isWeight ? `${value} kg` : value, t(isWeight ? "imc.weight" : "imc.imcLabel")], [isWeight, t]);
  return <div className="w-full min-w-0" data-testid={testId}>
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke="#2d3f5a" />
        <XAxis dataKey="date" stroke="#8a9bb5" tick={TICK} />
        <YAxis stroke="#8a9bb5" tick={TICK} domain={DOMAIN} width={52} />
        <Tooltip contentStyle={TOOLTIP} labelStyle={LABEL} formatter={formatter} />
        {!isWeight && <><ReferenceLine y={18.5} stroke="#60a5fa" strokeDasharray="4 4" /><ReferenceLine y={25} stroke="#4ade80" strokeDasharray="4 4" /><ReferenceLine y={30} stroke="#facc15" strokeDasharray="4 4" /></>}
        <Line isAnimationActive={false} type="monotone" dataKey={metric} stroke={isWeight ? "#c9a84c" : "#818cf8"} strokeWidth={2} dot={isWeight ? WEIGHT_DOT : IMC_DOT} activeDot={ACTIVE_DOT} />
      </LineChart>
    </ResponsiveContainer>
  </div>;
});